import React, { useState } from 'react';
import { map } from 'lodash';
import {
  Dropdown,
  Menu,
  Item,
  Select,
  Field,
} from '@zendeskgarden/react-dropdowns';
// import { Select, Item } from '@zendeskgarden/react-select';

// TODO

const PaginationDropdown = ({ length, items, value, type, onChange }) => {
  const key = type === 'page' ? 'page' : 'limit';
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  return (
    <Dropdown
      className="dropdown"
      selectedItem={value}
      onSelect={(v) => onChange({ [key]: v })}
      onStateChange={(changes) => {
        if (
          changes.isOpen !== menuIsOpen &&
          Object.prototype.hasOwnProperty.call(changes, 'isOpen')
        ) {
          setMenuIsOpen(changes.isOpen);
        }
      }}
    >
      <Field>
        <Select pagination>
          {type === 'page' ? 'Page' : 'Limit'} {value}
        </Select>
      </Field>
      {!menuIsOpen ? null : (
        <Menu maxHeight={'200px'}>
          {map(items, ({ key, value }) => {
            return (
              <Item defaultSpacing value={value} key={key}>
                {value}
              </Item>
            );
          })}
        </Menu>
      )}
    </Dropdown>
  );
};

export default PaginationDropdown;
